(function($) {
  'use strict';

  if (!$) {
    return;
  }

  var MIN_CHARACTERS = 2;
  var RESULT_LIMIT = 6;
  var DEBOUNCE_DELAY = 250;

  function escapeHtml(value) {
    return $('<div>').text(value || '').html();
  }

  function formatMoney(value) {
    var cents = Math.round(parseFloat(value || 0) * 100);

    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.strings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function resizeImageUrl(url) {
    if (!url) {
      return '';
    }

    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=112';
  }

  function AjaxSearch(form) {
    this.$form = $(form);
    this.$input = this.$form.find('[data-ajax-search-input]');
    this.$results = this.$form.find('[data-ajax-search-results]');
    this.$status = this.$form.find('[data-ajax-search-status]');
    this.timer = null;
    this.request = null;
    this.activeIndex = -1;
    this.lastQuery = '';
    this.bindEvents();
  }

  AjaxSearch.prototype.bindEvents = function() {
    var self = this;

    this.$input.on('input.ajaxSearch', function() {
      window.clearTimeout(self.timer);
      self.timer = window.setTimeout(function() {
        self.search();
      }, DEBOUNCE_DELAY);
    });

    this.$input.on('focus.ajaxSearch', function() {
      if (self.lastQuery === $.trim(self.$input.val()) && self.$results.children().length) {
        self.open();
      }
    });

    this.$input.on('keydown.ajaxSearch', function(event) {
      self.onKeydown(event);
    });

    this.$form.on('submit.ajaxSearch', function() {
      var query = $.trim(self.$input.val()).replace(/\*+$/, '');

      if (query) {
        self.$input.val(query + '*');
      }
    });

    $(document).on('mousedown.ajaxSearch touchstart.ajaxSearch', function(event) {
      if (!self.$form[0].contains(event.target)) {
        self.close();
      }
    });
  };

  AjaxSearch.prototype.search = function() {
    var self = this;
    var query = $.trim(this.$input.val());

    if (query.length < MIN_CHARACTERS) {
      this.lastQuery = '';
      this.close(true);
      return;
    }

    if (this.request) {
      this.request.abort();
    }

    this.lastQuery = query;
    this.activeIndex = -1;
    this.$results.html('<p class="ajax-search__message">Buscando&hellip;</p>');
    this.$status.text('Buscando');
    this.open();

    var root = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';

    this.request = $.ajax({
      url: root + 'search/suggest.json',
      dataType: 'json',
      data: {
        q: query,
        'resources[type]': 'product',
        'resources[limit]': RESULT_LIMIT,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,vendor,variants.title'
      }
    }).done(function(response) {
      if (query !== $.trim(self.$input.val())) {
        return;
      }

      var products = response &&
        response.resources &&
        response.resources.results &&
        response.resources.results.products
          ? response.resources.results.products
          : [];

      self.render(products, query);
    }).fail(function(xhr, status) {
      if (status !== 'abort') {
        self.$results.html('<p class="ajax-search__message">No fue posible cargar las sugerencias.</p>');
        self.$status.text('No fue posible cargar las sugerencias');
        self.open();
      }
    }).always(function() {
      self.request = null;
    });
  };

  AjaxSearch.prototype.render = function(products, query) {
    var html = '';
    var searchUrl = '/search?q=' + encodeURIComponent(query + '*');

    if (this.$form.find('input[name="type"][value="product"]').length) {
      searchUrl += '&type=product';
    }

    if (!products.length) {
      this.$results.html('<p class="ajax-search__message">No encontramos productos.</p>');
      this.$status.text('No se encontraron productos');
      this.open();
      return;
    }

    $.each(products, function(index, product) {
      var image = product.featured_image && product.featured_image.url
        ? product.featured_image.url
        : product.image;
      var comparePrice = parseFloat(product.compare_at_price_min || 0);
      var price = parseFloat(product.price_min || product.price || 0);

      html += '<a class="ajax-search__item" role="option" href="' + escapeHtml(product.url) + '" data-ajax-search-option>';
      html += image
        ? '<img class="ajax-search__image" src="' + escapeHtml(resizeImageUrl(image)) + '" alt="" width="56" height="56" loading="lazy">'
        : '<span class="ajax-search__image ajax-search__image--empty"></span>';
      html += '<span class="ajax-search__details">';
      html += '<span class="ajax-search__title">' + escapeHtml(product.title) + '</span>';
      if (product.vendor) {
        html += '<span class="ajax-search__vendor">' + escapeHtml(product.vendor) + '</span>';
      }
      html += '<span class="ajax-search__price">' + escapeHtml(formatMoney(price));
      if (comparePrice > price) {
        html += '<span class="ajax-search__compare-price">' + escapeHtml(formatMoney(comparePrice)) + '</span>';
      }
      html += '</span></span></a>';
    });

    html += '<a class="ajax-search__all" role="option" href="' + escapeHtml(searchUrl) + '" data-ajax-search-option>';
    html += 'Ver todos los resultados para &ldquo;' + escapeHtml(query) + '&rdquo;</a>';

    this.$results.html(html);
    this.$status.text(products.length + ' productos encontrados');
    this.open();
  };

  AjaxSearch.prototype.getOptions = function() {
    return this.$results.find('[data-ajax-search-option]');
  };

  AjaxSearch.prototype.onKeydown = function(event) {
    var $options = this.getOptions();

    if (event.keyCode === 27) {
      this.close();
      return;
    }

    if (!$options.length || this.$results.prop('hidden')) {
      return;
    }

    if (event.keyCode === 40) {
      event.preventDefault();
      this.activeIndex = (this.activeIndex + 1) % $options.length;
      this.highlight($options);
    } else if (event.keyCode === 38) {
      event.preventDefault();
      this.activeIndex = this.activeIndex <= 0 ? $options.length - 1 : this.activeIndex - 1;
      this.highlight($options);
    } else if (event.keyCode === 13 && this.activeIndex >= 0) {
      event.preventDefault();
      window.location.href = $options.eq(this.activeIndex).attr('href');
    }
  };

  AjaxSearch.prototype.highlight = function($options) {
    $options.removeClass('is-active').attr('aria-selected', 'false');
    $options.eq(this.activeIndex).addClass('is-active').attr('aria-selected', 'true');
  };

  AjaxSearch.prototype.open = function() {
    this.$results.prop('hidden', false);
    this.$input.attr('aria-expanded', 'true');
  };

  AjaxSearch.prototype.close = function(clearResults) {
    this.$results.prop('hidden', true);
    this.$input.attr('aria-expanded', 'false');
    this.activeIndex = -1;

    if (clearResults) {
      this.$results.empty();
      this.$status.empty();
    }
  };

  AjaxSearch.prototype.reset = function() {
    window.clearTimeout(this.timer);

    if (this.request) {
      this.request.abort();
      this.request = null;
    }

    this.lastQuery = '';
    this.$input.val('');
    this.close(true);
  };

  $(function() {
    $('[data-ajax-search]').each(function() {
      var instance = new AjaxSearch(this);
      $(this).data('ajaxSearchInstance', instance);
    });

    var searchDrawerWasOpen = $('body').hasClass('js-drawer-open-top') ||
      $('html').hasClass('js-drawer-open-top');

    var drawerObserver = new MutationObserver(function() {
      var searchDrawerIsOpen = $('body').hasClass('js-drawer-open-top') ||
        $('html').hasClass('js-drawer-open-top');

      if (searchDrawerWasOpen && !searchDrawerIsOpen) {
        $('#SearchDrawer [data-ajax-search]').each(function() {
          var instance = $(this).data('ajaxSearchInstance');

          if (instance) {
            instance.reset();
          }
        });
      }

      searchDrawerWasOpen = searchDrawerIsOpen;
    });

    drawerObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    drawerObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
})(window.jQuery);
